import React, {useState, useRef} from 'react';
import classnames from 'classnames';
import Validate from 'react-form-controlled-validate';
import {Form, Input} from 'react-form-controlled';
import {FormattedMessage} from 'react-intl';
import MessageIfPresent from '@ignitesales/neuro-application/src/components/MessageIfPresent';

const shareViaEmailSchema = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z0-9]+\\.)+[a-zA-Z]{2,}))$',
    }
  },
  required: ['email']
};

const ShareViaEmail = ({className, onSubmit, sendEmail, initialValue = null}) => {

  const classes = classnames(className, 'shareViaEmail');
  const [formData, updateFormData] = useState({email: initialValue});
  const [showError, setShowError] = useState(false);
  const formRef = useRef(null);

  const onChange = async (data) => {
    const errors = await formRef.current.validate(data);
    setShowError(errors.length !== 0);
    updateFormData(data);
  };

  const onFormSubmit = (data) => {
    sendEmail(data.email);
    onSubmit();
  };


  return <section className={classes}>
    <Validate schema={shareViaEmailSchema} ref={formRef}>
      <Form onSubmit={onFormSubmit} value={formData} onChange={onChange}>
        <FormattedMessage id="shareViaEmail.label" tagName="label"/>
        <Input aria-label="email" type="text" debounce={0} name="email"/>
        <MessageIfPresent id="shareViaEmail.error">
          { showError ? <span className="text-danger"><FormattedMessage id="shareViaEmail.error" tagName="p"/></span> : ''}
        </MessageIfPresent>
        <button type="submit" className="btn" disabled={showError}><FormattedMessage id="shareViaEmail.button"/></button>
      </Form>
    </Validate>
  </section>;
};

export default ShareViaEmail;
